import { useSelector } from 'react-redux';

import { getCompanyId } from 'src/core/selectors/globalSelectorsTyped';

export const useCompanyId = (): string => useSelector(getCompanyId);
